import { render, staticRenderFns } from "./SplitPurchaseInvoiceRow.vue?vue&type=template&id=74a3ed14"
import script from "./SplitPurchaseInvoiceRow.vue?vue&type=script&lang=ts"
export * from "./SplitPurchaseInvoiceRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports